// must be the same as bootstrap
export const SCREEN_SM_MIN = 768
export const SCREEN_MD_MIN = 992
export const SCREEN_LG_MIN = 1200

export function supportCORS() {
    return 'withCredentials' in new XMLHttpRequest()
}

export function supportHistory() {
    return window.history && window.history.pushState && true || false
}

export function supportWorker() {
    if (isIE('edge')) return false // IE Edge is buggy https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9243268/
    return window.Worker && true || false
}

export function supportWebSocket() {
    return window.WebSocket && true || false
}

export function isIE(version) {
    const userAgent = navigator.userAgent.toLowerCase()

    var ieVersion

    if (userAgent.indexOf('msie') >= 0) {
        ieVersion = parseInt(userAgent.split('msie')[1])
    } else if (userAgent.indexOf('trident/') >= 0) {
        ieVersion = 11
    } else if (userAgent.indexOf('edge/') >= 0) {
        ieVersion = 'edge'
    }

    if (ieVersion && version) return ieVersion == version
    if (ieVersion) return true
    return false
}

export function screenSize() {
    const width = window.innerWidth

    if (width >= SCREEN_LG_MIN) return 'lg'
    if (width >= SCREEN_MD_MIN) return 'md'
    if (width >= SCREEN_SM_MIN) return 'sm'
    return 'xs'
}

export function mediaQuery() {
    const width = window.innerWidth

    if (width >= SCREEN_LG_MIN) return ['lg', 'md', 'sm', 'xs']
    if (width >= SCREEN_MD_MIN) return ['md', 'sm', 'xs']
    if (width >= SCREEN_SM_MIN) return ['sm', 'xs']
    return ['xs']
}

export function matchMedia(size) {
    return mediaQuery().indexOf(size) > -1
}

export function scrollTop(duration) {
    const start = document.body.scrollTop
    const change = -start
    const increment = 20

    function easeInOut(currentTime, start, change, duration) {
        currentTime /= duration / 2

        if (currentTime < 1) {
            return change / 2 * currentTime * currentTime + start
        }

        currentTime -= 1
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start
    }

    function animateScroll(elapsedTime) {        
        elapsedTime += increment
        var position = easeInOut(elapsedTime, start, change, duration)
        document.body.scrollTop = position

        if (elapsedTime < duration) {
            setTimeout(() => animateScroll(elapsedTime), increment)
        }
    }

    animateScroll(0)
}

export function resolveLocationPathname(nextPathname) {
    const pathnameSegments = window.location.pathname.split('/').slice(1)

    nextPathname = nextPathname.replace(/^\/\*\//, '/' + pathnameSegments[0] + '/')
    nextPathname = nextPathname.replace(/^(\/[\w-]+)\/\*\//, '$1/' + pathnameSegments[1] + '/')
    nextPathname = nextPathname.replace(/^(\/[\w-]+\/[\w-]+)\/\*\//, '$1/' + pathnameSegments[2] + '/')
    return nextPathname
}


// WEBPACK FOOTER //
// ./lib/core/browser.js